import { computed } from 'vue'
import { router, usePage } from '@inertiajs/vue3'
import { UserData } from '@/Support/Users/Interfaces/UserData'
import { TeamData } from '@/Support/Teams/Interfaces/TeamData'
import { routing } from '@/Support/Routing/Functions/routing'
import { useAppLayout } from '@/stores/appLayout'
import { CommandPaletteAction } from '@/Support/CommandPalette/Contracts/CommandPalette'
import { t } from '@/Support/lang'
import { useNotifications } from '@/stores/notifications'
import { teamSwitchNotification } from '@/Support/Teams/Functions/switchTeamNotification'

export function useTeams(emit?: (event: string) => void) {
  const { newMiniNotification } = useNotifications()
  const user = computed(() => usePage().props.user as unknown as UserData)

  const currentTeam = computed<TeamData>(() => user.value.currentTeam)
  const allTeams = computed<TeamData[]>(() => user.value.allTeams)

  const allTeamAsCommands = computed<CommandPaletteAction[]>(() =>
    allTeams.value.map((team: TeamData) => ({
      name: t('command-palette.actions.name.switch_team', { team: team.name }),
      value: team.id,
      icon: 'organization',
      url: '',
      type: 'switchTeam',
      tags: [],
    })),
  )

  const { cleanAiQuery } = useAppLayout()

  const switchToTeam = (team: string | TeamData) => {
    const teamId = typeof team === 'string' ? team : team.id
    if (emit) emit('selected')

    router.put(
      routing('teams.switch'),
      {
        team_id: teamId,
      },
      {
        preserveState: false,
        onSuccess: () => {
          cleanAiQuery()
          teamSwitchNotification()
        },
      },
    )
  }

  return {
    user,
    currentTeam,
    allTeams,
    switchToTeam,
    allTeamAsCommands,
  }
}
